// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2nlEf","header":"ClearentDisclaimer_header__2qZ3I","inner":"ClearentDisclaimer_inner__2pXYO"};